// data/languages/swahili/categories/salutations.ts

import { CategoryData } from '../../../../types/types';

export const salutations: CategoryData = {


  'Kwaheri': { translation: 'Au revoir', translationEn: 'Goodbye', audio: 'Sw-Kwaheri' },
  'Habari?': { translation: 'Comment ça va ?', translationEn: 'How are you?', audio: 'Sw-Habari' },
  'Mzuri': { translation: 'Bien (familier ; forme standard : « Nzuri »)', translationEn: 'Fine (colloquial; standard form: "Nzuri")', audio: 'Sw-Mzuri' },
  'Asante': { translation: 'Merci', translationEn: 'Thank you', audio: 'Sw-Asante' },
  'Hakuna matata': { translation: 'De rien / Pas de problème', translationEn: 'You\'re welcome / No problem', audio: 'Sw-Hakuna_matata' },
  'Samahani': { translation: 'Excusez-moi / Désolé', translationEn: 'Excuse me / Sorry', audio: 'Sw-Samahani' },
  'Usiku mwema': { translation: 'Bonne nuit', translationEn: 'Good night', audio: 'Sw-Usiku_mwema' },
  'Heri ya kula': { translation: 'Bon appétit', translationEn: 'Enjoy your meal', audio: 'Sw-Heri_ya_kula' },
  'Habari ya siku?': { translation: 'Comment s’est passée ta journée ?', translationEn: 'How was your day?', audio: 'Sw-Habari_ya_siku' },
  'Umelala vizuri?': { translation: 'As-tu bien dormi ?', translationEn: 'Did you sleep well?' },
  'Habari za nyumbani?': { translation: 'Comment va la famille ?', translationEn: 'How is the family?', audio: 'Sw-Habari_za_nyumbani' },
  'Mambo vipi?': { translation: 'Comment ça va ? / Quoi de neuf ?', translationEn: 'How\'s it going? / What\'s up?', audio: 'Sw-Mambo_vipi' },
  'Salama': { translation: 'En paix / Ça va bien', translationEn: 'At peace / All is well', audio: 'Sw-Salama' },
  'Nzuri tu': { translation: 'Très bien / Ça va', translationEn: 'Very well / Fine' },
  'Ndiyo': { translation: 'Oui', translationEn: 'Yes', audio: 'Sw-Ndiyo' },
  'Hapana': { translation: 'Non', translationEn: 'No', audio: 'Sw-Hapana' },
  'Karibu': { translation: 'Bienvenue / Je vous en prie', translationEn: 'Welcome / You\'re welcome', audio: 'Sw-Karibu' },
  'Habari za asubuhi': { translation: 'Bonjour (le matin)', translationEn: 'Good morning', audio: 'Sw-Habari_za_asubuhi' },
  'Habari za mchana': { translation: 'Bon après-midi', translationEn: 'Good afternoon', audio: 'Sw-Habari_za_mchana' },

};

export default salutations;

export {};
